import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from 'app/validation.service';
import { JobService } from 'app/jobService';

import { Router } from '@angular/router';

@Component({
  selector: 'apply-job-section2',
  templateUrl: './apply-job-section2.component.html',
  styleUrls: ['./apply-job-section2.component.scss']
})
export class ApplyJobSection2Component implements OnInit {

  @ViewChild('fileInput') fileInput

  positionForm: any;

  positionData: Object[];

  fileNameDefault: boolean;
  fileNameLink: boolean;

  showOrHide: boolean;

  constructor(private formBuilder: FormBuilder, private js: JobService, private router: Router) {
    this.fileNameDefault = true;
    this.fileNameLink = false;
    this.showOrHide = true;
    this.positionData = null;
  }

  ngOnInit() {
    //alert(this.js.jobPosition);
    this.js.navigate = 2;

    this.GetJobPositionApplyJob();

    this.positionForm = this.formBuilder.group({
      'positionJob': [this.js.jobPosition, [Validators.required]],
      //'positionJob': ["", [Validators.required]],
    });

    this.positionForm.get('positionJob').valueChanges.subscribe(value => {
      this.js.jobPosition = value;
    });

    this.RenderFileName();
  }

  GetJobPositionApplyJob() {
    this.js.GetApplyJobPosition().subscribe(
      (listPosition) => {
        //alert(JSON.stringify(this.positionData));
        this.positionData = null;
        //alert(this.positionData);
        this.positionData = JSON.parse(JSON.stringify(listPosition));
        //alert(JSON.stringify(this.positionData));
      },
      (error) => { alert(JSON.stringify(error)) },
      () => {

      }
    );
  }

  EditPositionApplyJob() {
    this.js.EditPositionApplyJobAPI().subscribe(
      (applyJobID) => {
        if (Number(applyJobID) != 0) {
          // this.positionForm.get('positionJob').valueChanges.subscribe(value => {
          //   this.js.jobPosition = value;
          // });

          this.GoToapplyjobsection3();
        } else {
          alert("กรุณาเลือกตำแหน่งาน")
        }
      },
      (error) => { alert(JSON.stringify(error)) },
      () => {

      }
    );
  }

  GoToapplyjobsection3() {
    //เช็คกับ server ว่ามีไฟล์ไหม
    // this.js.CheckUrlResume().subscribe(
    //   (urlVDO) => {
    //     if (urlVDO == "ไม่พบไฟล์") {
    //       alert("กรุณาอัพโหลด Resume ให้เรียบร้อยก่อน")
    //       return;
    //     } else {
    //       //ไปหน้าต่อไป
    //       this.router.navigateByUrl('applyjobsection3');
    //     }
    //   },
    //   (error) => { alert(JSON.stringify(error)) },
    //   () => {

    //   }
    // );

    this.router.navigateByUrl('applyjobsection3');
  }

  Upload() {
    var files: FileList = this.fileInput.nativeElement.files;
    if (files.length === 0) {
      alert("กรุณาเลือกไฟล์ก่อนกดปุ่ม Upload");
      this.RenderFileName();
      return;
    } else {
      this.showOrHide = false;
    }

    this.js.Upload(files[0], "resume").subscribe((data) => {
      this.js.fileResume = data;
      this.RenderFileName();
      this.showOrHide = true;
    },
      (error) => { alert(JSON.stringify(error)) },
      () => {
        this.showOrHide = true;
      }
    )
  }

  RenderFileName() {
    if (this.js.fileResume != "ยังไม่มีไฟล์แนบ") {
      this.fileNameDefault = false;
      this.fileNameLink = true;
    } else {
      this.fileNameDefault = true;
      this.fileNameLink = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/apply-job-section2/apply-job-section2.component.ts